import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';
import checkUndefinedNullOrEmpty from '../../../utils/tools/checkUndefinedNullOrEmpty';
import getStyleQuery from '../../../utils/tools/getStyleQuery';
import Iconify from '../../iconify/component';
import type { RHFCheckboxProps } from './types';

export default function RHFCheckbox({ disabled, helperText, icon, label, name, outlined, sx, uncheckIsNull }: RHFCheckboxProps) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) =>
                outlined ? (
                    <TextField
                        disabled={disabled}
                        error={!!error}
                        fullWidth
                        helperText={error ? error?.message : helperText}
                        inputProps={{
                            sx: { [getStyleQuery()]: { cursor: disabled ? 'default' : 'pointer' } },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Checkbox
                                        checked={field.value}
                                        disabled={disabled}
                                        disableRipple
                                        inputProps={{ 'aria-label': label?.toString() }}
                                        sx={{ [getStyleQuery()]: { fontSize: (theme) => theme?.rawTypography?.h4?.fontSize, p: 0 } }}
                                    />
                                </InputAdornment>
                            ),
                            readOnly: true,
                            startAdornment: !checkUndefinedNullOrEmpty(icon) ? (
                                <InputAdornment position="start" sx={{ pr: 0.5 }}>
                                    <Iconify icon={icon} />
                                </InputAdornment>
                            ) : undefined,
                            sx: { [getStyleQuery()]: { cursor: disabled ? 'default' : 'pointer' } },
                        }}
                        InputLabelProps={{
                            shrink: false,
                            sx: { [getStyleQuery()]: { color: 'text.secondary', cursor: disabled ? 'default' : 'pointer', ml: !checkUndefinedNullOrEmpty(icon) ? 5 : undefined, top: 1 } },
                        }}
                        label={label}
                        onClick={() =>
                            field.onChange({
                                target: {
                                    value: uncheckIsNull === true && field?.value === true ? null : !field.value,
                                },
                            })
                        }
                        sx={{ [getStyleQuery()]: { cursor: disabled ? 'default' : 'pointer' } }}
                        variant="outlined"
                    />
                ) : (
                    <FormControl sx={sx}>
                        <FormControlLabel
                            data-testid={`RHFCheckbox_${name}`}
                            control={
                                <Checkbox
                                    {...field}
                                    disabled={disabled}
                                    checked={field.value}
                                    inputProps={{ 'aria-label': label?.toString() }}
                                />
                            }
                            label={label}
                        />
                        {(!!error || helperText) && <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>}
                    </FormControl>
                )
            }
        />
    );
}
